import { SITE_NAME } from '@/constants/globals'
export const translations = {
    testimonialsHeading: `Co Mówią Czytelnicy o ${SITE_NAME}`,
    testimonialsSubHeadline: `Opinie Użytkowników`,
};

export default translations;
